import { color } from 'd3-color';
import styled from "styled-components";
import { ThemeType } from "../../types/Theme";


export const GraficosMetricas = styled.div<{ theme: ThemeType }>`
  padding: 0rem 10rem 10rem;
  .cabecalhoMetricas{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;

    .tituloMetricas{
      color: ${(props) => props.theme.colors.secondary};
      
      width: 100%;
      text-align: justify;

      display: flex;
      flex-direction: column;
      gap: 4px;

      span {
        color: ${({ theme }) => theme.colors.tertiary};
        font-weight: 400;
        text-align: left;
      }
    }

    .filtrosMetricas{
      display: flex;
      gap: 16px;
      width: 100%;
      justify-content: flex-end;

      /* Aplica max-width a todos os filhos diretos (Select e FiltrosData) */
      > * {
        width: 100%;
        max-width: 250px;
      }

      .view-select{
        width: 100%;
        max-width: 250px;
      }

      .containerDropdown{
        width: 100%;
        max-width: 250px;

        .dropdown{
          right: 0;
          left: auto;
        }
      }

      @media (max-width: 1200px) {
        flex-direction: column;
        gap: 1rem;

        > *,
        .view-select,
        .containerDropdown{
          max-width: 100%;
        }
      }
    }
  }

  .conteudoMetricas{
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  @media (max-width: 1200px) {
    padding: 1rem 3rem 10rem;

    .cabecalhoMetricas{
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      padding: 0 0 16px;
    }
  }
`;

export const LinhaCards = styled.div<{ theme: ThemeType }>`
  display: grid;
  grid-template-columns: repeat(2,1fr);
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(1,1fr);
  }

  .quantidadesPedidosSacolas{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 16px;

    .sacolas{
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  .faturamento{
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const Card = styled.div<{ theme: ThemeType }>`
  background: ${(props) => props.theme.colors.white};
  border-radius: 24px;
  padding: 24px 32px;

  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  
  height: 100%;

  @media (max-width: 1200px) {
      padding: 16px;
    }

  .headerCard{
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
  }

  .tabela{
    width: 100%;
    .cabecalhoTabela{
      tr{
        th{
          color: ${(props) => props.theme.colors.tertiary};
          text-align: left;
        }
      }
    }

    .bodyTabela{
      tr{
        td{
          color: ${(props) => props.theme.colors.tertiary};
          text-align: left;
          padding: 4px 0;

          img{
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }
  .grafico {
    width: 100%;
    height: 300px;
  }

  .graficoPedidosEstado {
    width: 100%;
    height: 300px;
  }

  .graficoPedidosCupom {
    width: 100%;
    height: 300px;
  }

  .graficosPedidos {
    width: 100%;
    height: 300px;
  }
`;

export const TituloCard = styled.div<{ theme: ThemeType }>`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.tertiary};
  gap: 8px;

  .textoTitulo{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }

  .iconCard{
    min-width: 32px;
    min-height: 32px;
    max-width: 32px;
    max-height: 32px;

    @media (max-width: 1200px) {
      min-width: 24px;
      min-height: 24px;
      max-width: 24px;
      max-height: 24px;
    }
  }
`;

export const ListagemPorSituacao = styled.div<{ theme: ThemeType }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  gap: 8px;

  .linhaSituacao{
    display: flex;
    gap: 8px;
    align-items: center;
    color: ${(props) => props.theme.colors.tertiary};

    .situacao{
      display: flex;
      align-items: center;
      gap: 8px;

      .corSituacao{
        width: 16px;
        height: 16px;
        border-radius: 50%;
      }
    }
  }
`;

export const QuantidadesCard = styled.div<{ theme: ThemeType }>`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  width: auto;

  .fonteSubtitulo{
    color: ${({ theme }) => theme.colors.tertiary};
  }

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-end;
  }
`;

export const QuantidadesCardSacola = styled.div<{ theme: ThemeType }>`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  width: 100%;

  .fonteSubtitulo{
    color: ${({ theme }) => theme.colors.tertiary};
  }

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const QuantidadesCardTicket = styled.div<{ theme: ThemeType }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;

  .fonteSubtitulo{
    color: ${({ theme }) => theme.colors.tertiary};
    white-space: nowrap;
  }
`;

export const TagDownCard = styled.div<{ theme: ThemeType }>`
  .destaqueDownCard{
    border-radius: 16px;
    font-weight: 700;
    padding: 2px 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    background-image: ${({ theme }) =>
    theme.mode == "light"
      ? "none"
      : "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))"};
    background-blend-mode: ${({ theme }) =>
    theme.mode == "light"
      ? "normal"
      : "multiply"};

    background-color: ${({ theme }) => theme.colors.dashBgDown};
    border: 0.5px solid ${({ theme }) => theme.colors.dashBorderDown};
    color: ${({ theme }) => theme.colors.dashBorderDown};
  }
`;

export const TagUpCard = styled.div<{ theme: ThemeType }>`
  .destaqueUpCard{
    border-radius: 16px;
    font-weight: 700;
    padding: 2px 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    background-image: ${({ theme }) =>
    theme.mode == "light"
      ? "none"
      : "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))"};
    background-blend-mode: ${({ theme }) =>
    theme.mode == "light"
      ? "normal"
      : "multiply"};

    background-color: ${({ theme }) => theme.colors.dashBgUp};
    border: 0.5px solid ${({ theme }) => theme.colors.dashBorderUp};
    color: ${({ theme }) => theme.colors.dashBorderUp};
  }
`;